import { useFeatureFlagEnabled } from "posthog-js/react"
import { STOP_TO_STOP_DISTANCE_FLAG } from "@/lib/stopDistance"

/** Mirrors the hook of the same name in the mobile client. */
export const useStopToStopDistance = (): boolean =>
  Boolean(useFeatureFlagEnabled(STOP_TO_STOP_DISTANCE_FLAG))
